import { Dialog, styled } from '@mui/material';

const StyledDialogWide: typeof Dialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': { backgroundColor: '#fff', width: '1200', maxWidth: '85vw !important' },
  '& .MuiDialogTitle-root': {
    'background': theme.palette.primary.main,
    'color': theme.palette.primary.contrastText,
    'fontWeight': 'bold',
    'lineHeight': 1,
    'padding': '16px 96px',
    'position': 'relative',
    'textAlign': 'center',
    'whiteSpace': 'nowrap',
    '& .MuiButton-root': {
      fontSize: '1rem',
      height: '100%',
      position: 'absolute',
      left: 0,
      top: 0
    }
  },
  '& .MuiDialogContent-root': {
    'margin': 'auto',
    'padding-right': '0px',
    'padding-left': '0px',
    'img': { padding: 24 },
    '& .MuiDialogContentText-root': {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
      textAlign: 'center',
      lineHeight: 5
    },
    '& .MuiButton-sizeSmall': {
      border: '2px solid',
      color: theme.palette.info.main,
      fontSize: '1rem',
      fontWeight: 'bold'
    },
    '& .MuiButton-sizeMedium': { fontSize: '1rem', minWidth: 144 },
    '& .MuiButton-sizeLarge': {
      border: '2px solid',
      color: theme.palette.info.main,
      fontSize: '1.25rem',
      whiteSpace: 'noWrap'
    },
    '& .MuiIconButton-root': { borderRadius: 4, padding: 'calc(50% - 26px) 0', width: '100%' },
    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#0009', borderWidth: 2 },
    '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': { fontSize: '1rem' },
    '& .MuiGrid-item:not(.MuiGrid-container)': { padding: 8 },
    '& .MuiSvgIcon-fontSizeLarge': { fontSize: '3rem' }
  }
}));

export default StyledDialogWide;
